import { Highlight, themes } from "prism-react-renderer";
import { Card, CardBody, Col } from "reactstrap";
import { javaData } from "../../../../Data/Editor/Editor";
import CardHeaderCommon from "../../../../Utils/CommonComponents/CardHeaderCommon";
import { JavascriptModeTitle } from "../../../../Utils/Constants";

const JavascriptMode = () => {
  return (
    <Col xl="6">
      <Card>
        <CardHeaderCommon title={JavascriptModeTitle} />
        <CardBody>
          <Highlight theme={themes.vsDark} code={javaData} language="javascript">
            {({ style, tokens, getLineProps, getTokenProps }) => (
              <pre style={style}>
                {tokens.map((line, i) => (
                  <div key={i} {...getLineProps({ line })}>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </CardBody>
      </Card>
    </Col>
  );
};

export default JavascriptMode;
